export default {
  projectInfo: null,
  legalInfo: null,
  error: false,
  loading: false,
  cardContent: null,
}
